import { IconButton, TextField, Autocomplete, AutocompleteRenderInputParams } from '@mui/material';
import { FC, useRef, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import HelperModal from '@acorn-portal/shared/src/components/modal/HelperModal';
import FormField from '@acorn-portal/shared/src/components/inputs/FormField';

interface IModal {
	title: string;
	description: string;
}
interface AutocompleteOption {
	[key: string]: unknown;
}

interface IProps {
	onChange: (value: string) => void;
	name?: string;
	id?: string;
	error?: boolean;
	helperText?: string | false;
	value?: unknown;
	label: string;
	modal?: IModal;
	options: AutocompleteOption[];
}

const AutoCompleteFormField: FC<IProps> = ({
	error,
	helperText,
	id,
	label,
	options,
	modal,
	onChange,
	value,
	...rest
}) => {
	const [open, toggleModal] = useState(false);
	const data = options?.filter((x) => !x.hidden);

	const [inputValue, setInputValue] = useState('');
	const inputRef = useRef<HTMLInputElement>(null);

	const getSelectedItem = (): AutocompleteOption | null => {
		const item = data?.find((opt) => opt.value === value);
		return (item as AutocompleteOption) || null;
	};

	return (
		<>
			<FormField error={error} helperText={helperText} id={id} label={label}>
				<Autocomplete<AutocompleteOption>
					fullWidth
					disablePortal
					id={id}
					value={getSelectedItem()}
					options={data}
					onChange={(_event, newValue) => {
						if (!newValue) return;
						inputRef.current?.blur?.();
						onChange(newValue.value as string);
					}}
					inputValue={inputValue}
					onInputChange={(_event, newInputValue) => {
						setInputValue(newInputValue);
					}}
					clearIcon={null}
					renderInput={(params: AutocompleteRenderInputParams) => (
						<TextField
							{...params}
							inputRef={inputRef}
							variant='outlined'
							id={id}
							fullWidth
							size='medium'
							sx={{
								width: modal ? '90%' : '100%',
								'& fieldset': {
									borderColor: error ? 'error.main' : 'unset',
								},
							}}
							{...rest}
						/>
					)}
				/>

				{modal && (
					<IconButton
						color='icon'
						aria-label={`${id ?? ''}-more-info`}
						component='span'
						sx={{ my: 1, width: '10%' }}
						onClick={() => toggleModal(true)}
					>
						<InfoIcon />
					</IconButton>
				)}
			</FormField>
			{modal && <HelperModal onClose={() => toggleModal(false)} open={open} {...modal} />}
		</>
	);
};

export default AutoCompleteFormField;
